<template>
  <div>
    <!-- BOC:[error] -->
    <AError :api="api"></AError>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>Move Student</v-card-title>
        <v-card-text>
          <template>
            <Institution :callbackSelect="selectInstitution" />
          </template>
          <template>
            <Classroom
              :institutionId="selectedInstitutionId"
              :callbackSelect="selectClassroom"
              ref="dropdown_classroom"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="validate">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import Institution from "@/components/Moderator/Student/Move/Institution";
import Classroom from "@/components/Moderator/Student/Move/Classroom";
import { mapState } from "vuex";
export default {
  props: ["self", "url", "callbackSuccess"],
  components: {
    Classroom,
    Institution,
  },
  computed: mapState({
    school: (state) => state.school.data,
  }),
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[form]
    form: {
      id: null,
      classroomId: null,
      institutionId: null,
    },
    selectedInstitutionId: null,
    fields: [],
    rules: {},
    //EOC
  }),

  created() {
    //BOC:[api]
    this.api.url = this.url;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  methods: {
    selectInstitution(val) {
      this.selectedInstitutionId = val;
      this.form.institutionId = val
      var that = this;
      setTimeout(() => {
        that.$refs["dropdown_classroom"].fetch();
      }, 100);
    },

    selectClassroom(val) {
      this.form.classroomId = val
    },
    entertName(name) {
      this.form.name = name;
    },
    selectDate(date, key) {
      if (key == "dateStart") {
        this.form.dateStart = date;
      } else {
        this.form.dateEnd = date;
      }
    },
    selectTime(time, key) {
      if (key == "timeStart") {
        this.form.timeStart = time;
      } else {
        this.form.timeEnd = time;
      }
    },
    //BOC:[form]
    validate() {
      this.api.callbackReset();
      if (this.$refs.form.validate()) {
        this.submit();
      } else {
        this.api.callbackError("Please check the form.");
      }
    },
    submit() {
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
    //EOC
  },
  mounted() {
    this.form.id = this.$route.params.id;
    this.form.classroomId = parseInt(this.$route.params.parentId);
    this.form.institutionId = parseInt(this.$route.params.grandParentId);
  },
};
</script>

<style>
</style>